var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup-overlay",on:{"click":_vm.closePopup}}),_c('div',{staticClass:"popup-body"},[_c('div',{staticClass:"popup-content"},[_c('div',{staticClass:"popup-simple"},[_c('i',{class:'icon-popup-' + _vm.iconType}),_c('span',{staticClass:"popup-textSimple"},[_vm._v(_vm._s(_vm.popupSimpleText))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }